import { Pipe, PipeTransform } from '@angular/core';
import { AccountAttributesEnum } from '../../enums';
import { UserService } from '../../../core/services/user.service';
import { Observable } from 'rxjs';

@Pipe({
    name: 'hasAccessAsync',
    standalone: false
})
export class HasAccessAsyncPipe implements PipeTransform {
    constructor(private readonly userService: UserService) {
    }
    transform(attributes: AccountAttributesEnum | AccountAttributesEnum[], every?: boolean): Observable<boolean> {
        return this.userService.hasAccessAsync(attributes, every);
    }
}
